<template>
  <div class="public-app">
    <!-- Mobile view -->
    <app v-if="isMobile"
         :calId="calId"
         :viewState="viewState"
         :schoolName="schoolName"
         :calName="calName"
         :i18n="i18n"
         @setLocale="setLocale"
         @eventClick="setActiveEvent">
    </app>
    <!-- Desktop View -->
    <template v-else>
    <desktop v-if="view === 'desktop'"
             :calId="calId"
             :schoolName="schoolName"
             :viewState="viewState"
             :i18n="i18n"
             @eventClick="setActiveEvent"
             @setLocale="setLocale">
    </desktop>
    <desktopVue
      v-if="view === 'smartscreen'"
      :calendarId="calId"
      :calendar="calendar">
    </desktopVue>
    </template>
    <transition name="aniZoomIn">
      <show-event
        v-if="activeEvent !== null"
        :locale="locale"
        :event="activeEvent"
        :i18n="i18n"
        @close="activeEvent = null">
      </show-event>
    </transition>
  </div>
</template>

<script>
import showEvent from './ShowEvent.vue'
import desktop from './Desktop/DesktopView.vue'
import DesktopVue from './Desktop/DesktopVue.vue'
import app from './Mobile/MobileView.vue'
import docendo from '../../docendo'

const I18N = {
  da: {
    out_of_school: 'Ude af huset',
    canceled: 'Aflyst'
  },
  en: {
    out_of_school: 'Out of school',
    canceled: 'Canceled'
  },
  nb: {
    out_of_school: 'Utenfor skolen',
    canceled: 'Avlyst'
  }
}

export default {
  components: {
    DesktopVue,
    showEvent,
    desktop,
    app
  },
  props: {
    calId: {
      type: Number,
      default: 405264
    }
  },
  data () {
    return {
      calendar: null,
      view: 'desktop',
      isMobile: false,
      activeEvent: null,
      viewState: 0,
      calName: '',
      schoolName: '',
      locale: window.USER && window.USER.locale ? window.USER.locale : 'en'
    }
  },
  computed: {
    i18n () {
      const loc = this.locale || 'en'
      return I18N[loc] || I18N['en']
    }
  },
  methods: {
    setLocale (val) {
      this.locale = val
    },
    setActiveEvent (event) {
      this.activeEvent = event
    },
    getSchoolInfo () {
      docendo.calendar(this.calId, (data) => {
        this.calendar = data
        this.calName = data.name
        this.viewState = data.view_state
      })
    }
  },
  beforeMount () {
    this.isMobile = ((/Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)))
    this.getSchoolInfo()
    if (window.location.href && window.location.href.indexOf('smartscreen') > -1) {
      this.view = 'smartscreen'
    }
  }
}
</script>

<style scoped>
.aniZoomIn-enter-active {
  animation: aniZoomIn .25s;
}

.aniZoomIn-leave-active {
  animation: aniZoomIn .25s reverse;
}

@keyframes aniZoomIn {
  from {
    opacity: 0;
    transform: scale3d(.3, .3, .3);
  }

  50% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// PublicContainer.vue?e456ba84